(function () {
  async function calculateCard(card) {
    if (!window.GCAMarketEngine || !window.GCAROIEngine) {
      console.warn("⚠️ Adapter: Engines not ready");
      return null;
    }

    const market = await window.GCAMarketEngine.getMarketEstimate(card);

    const roi = window.GCAROIEngine.calculateROI({
      buyPrice: card.buyPrice,
      marketValue: market.value,
      fees: card.fees || 0
    });

    return {
      market,
      roi
    };
  }

  window.GCACalculatorAdapter = {
    calculateCard
  };

  console.log("🧩 GCA Calculator Adapter loaded");
})();
